import { render, staticRenderFns } from "./RamsExternalSign.vue?vue&type=template&id=4ee9b079&"
import script from "./RamsExternalSign.vue?vue&type=script&lang=js&"
export * from "./RamsExternalSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports